module.exports = __webpack_public_path__ + "static/img/ad-bar2.2ed61a0a.png";